module.exports = __webpack_public_path__ + "static/mark-gaucher.dd7f54e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mark-gaucher.jpg
// module id = ./src/assets/images/mark-gaucher.jpg
// module chunks = 16228548823048030000